module.exports = __webpack_public_path__ + "static/media/Risorsa 013.cbe82653.svg";